import { ApproveLockDialog } from './approve-lock-dialog';
import { PaymentRunDetailSheet } from './payment-run-detail-sheet';
import { PaymentRunReviewFilters } from './payment-run-review-filters';
import { PaymentRunReviewTable } from './payment-run-review-table';
import { PaymentRunReviewToolbar } from './payment-run-review-toolbar';
import { PostponeDialog } from './postpone-dialog';
import { usePaymentRunReviewPage } from './use-payment-run-review-page';

export function PaymentRunReviewPage() {
  const page = usePaymentRunReviewPage();

  return (
    <div className='space-y-6'>
      <ApproveLockDialog {...page.approveDialog} />
      <PostponeDialog {...page.postponeDialog} />
      <PaymentRunDetailSheet {...page.detailSheet} />
      <PaymentRunReviewToolbar
        studioName={page.toolbar.studioName}
        startDate={page.toolbar.startDate}
        setStartDate={page.toolbar.setStartDate}
        endDate={page.toolbar.endDate}
        setEndDate={page.toolbar.setEndDate}
        nextRunAt={page.toolbar.nextRunAt}
        countdown={page.toolbar.countdown}
        readyCount={page.toolbar.readyCount}
        readySum={page.toolbar.readySum}
        flaggedCount={page.toolbar.flaggedCount}
        flaggedSum={page.toolbar.flaggedSum}
        removedCount={page.toolbar.removedCount}
        removedSum={page.toolbar.removedSum}
        totalCount={page.toolbar.totalCount}
        netSum={page.toolbar.netSum}
        currencySymbol={page.toolbar.currencySymbol}
        postponeButtonState={page.toolbar.postponeButtonState}
        postponeLimitReached={page.toolbar.postponeLimitReached}
        postponeCountMax={page.toolbar.postponeCountMax}
        openPostponeModal={page.toolbar.openPostponeModal}
        onDownloadCsv={page.toolbar.handleDownloadCSV}
        lockInteractionsDisabled={page.toolbar.lockInteractionsDisabled}
        incrementalLockAllowed={page.toolbar.incrementalLockAllowed}
        approveChargesToProcess={page.toolbar.approvePreview?.chargesToProcess}
        onOpenApproveModal={page.toolbar.openApproveModal}
        canUnlockRun={page.toolbar.canUnlockRun}
        paymentRunApproveLockEnabled={
          page.toolbar.paymentRunApproveLockEnabled
        }
        paymentRunPostponeCronEnabled={
          page.toolbar.paymentRunPostponeCronEnabled
        }
        unlockMutation={page.toolbar.unlockMutation}
        isRunLocked={page.toolbar.isRunLocked}
        approvedInvoiceIdsForRun={page.toolbar.approvedInvoiceIdsForRun}
        isPostponed={page.toolbar.isPostponed}
      />
      <PaymentRunReviewFilters
        filterTab={page.filters.filterTab}
        setFilterTab={page.filters.setFilterTab}
        setTablePage={page.filters.setTablePage}
        allFilterCount={page.filters.allFilterCount}
        readyCount={page.filters.readyCount}
        flaggedCount={page.filters.flaggedCount}
        removedCount={page.filters.removedCount}
        failedCount={page.filters.failedCount}
        successfulChargeCount={page.filters.successfulChargeCount}
        attentionCount={page.filters.attentionCount}
        searchTerm={page.filters.searchTerm}
        setSearchTerm={page.filters.setSearchTerm}
        setAppliedSearch={page.filters.setAppliedSearch}
        onSearch={page.filters.handleSearch}
      />
      <PaymentRunReviewTable
        isLoading={page.table.isLoading}
        isError={page.table.isError}
        onRefetch={page.table.refetch}
        lockHeaderAllChecked={page.table.lockHeaderAllChecked}
        lockHeaderIndeterminate={page.table.lockHeaderIndeterminate}
        onToggleSelectAllLockable={page.table.toggleSelectAllLockableInFilter}
        lockInteractionsDisabled={page.table.lockInteractionsDisabled}
        lockableSelectableForBulk={page.table.lockableSelectableForBulk}
        paginatedRows={page.table.paginatedRows}
        lockSelectionIds={page.table.lockSelectionIds}
        incrementalLockAllowed={page.table.incrementalLockAllowed}
        approvedForRunSet={page.table.approvedForRunSet}
        lockableIds={page.table.lockableIds}
        onToggleLockSelection={page.table.toggleLockSelection}
        onOpenRowDetail={page.table.openRowDetail}
        isPostponed={page.table.isPostponed}
        currencySymbol={page.table.currencySymbol}
        filteredTotal={page.table.filteredTotal}
        tablePageSize={page.table.tablePageSize}
        setTablePageSize={page.table.setTablePageSize}
        tablePageSafe={page.table.tablePageSafe}
        tableTotalPages={page.table.tableTotalPages}
        setTablePage={page.table.setTablePage}
        idsForFooterApproveStats={page.table.idsForFooterApproveStats}
        tableFooterSelectionStats={page.table.tableFooterSelectionStats}
        invoiceIdsPendingApprove={page.table.invoiceIdsPendingApprove}
        nextRunAt={page.table.nextRunAt}
        lockSelectionApprovePreview={page.table.lockSelectionApprovePreview}
        onOpenApproveModalForSelection={
          page.table.openApproveModalForSelectedRows
        }
        paymentRunApproveLockEnabled={
          page.table.paymentRunApproveLockEnabled
        }
        paymentRunPostponeCronEnabled={
          page.table.paymentRunPostponeCronEnabled
        }
        sortColumn={page.table.sortColumn}
        sortDirection={page.table.sortDirection}
        onRequestSort={page.table.onRequestSort}
      />
    </div>
  );
}
